import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
// import { getBackUrl } from 'helpers/back-url-store';
import DataProvider from 'api/data-provider';
import Dict from 'api/data-dict';
import pageCache from 'api/page-cache';
import preload from 'api/data-preload';
// import { blockPreloader } from 'containers/content-block';
import { simpleCheck } from 'api/data-check';
import seoPreload, { seoDecorator } from 'api/seo';
import { marketStatEvents, mstatDecorator } from 'subsys/market-stat';
import Counter from 'subsys/counter';
import Container from 'components/container';
import Row, { Col } from 'components/row';
import Breadcrumbs from 'components/breadcrumbs';
import Link from 'components/link';
import Icon, { iconTypes } from 'components/icon';
import { SeoText } from 'components/layouts';

// import blocksConfig from 'src-sites/bild/blocks/config';
import ContentProject from './content-project';

import translates from './project-i18n';

import 'styles/bildcontrol/section-project/_page-project.scss';

// const bemClasses = new Bem('project');
const classesBemToBack = new Bem('toBack');

@preload((routeProps) => {
  const { content, landing } = routeProps.params;
  let config = {
    ...pageCache('project'),
    project: [DataProvider.preload, {
      url: 'bildcontrol/newbuild',
      cache: 60,
      requestClientCache: 1,
      query: { id: landing.params.complex.id }
    }],
    creators: {
      $wait: ['project'],
      $callback: (data) => {
        const cfg = {};
        const ids = get(data, 'project.data[0].creator_ids');

        cfg.creatorList = ids ? [DataProvider.preload, {
          url: 'bild/clients-list',
          query: { ids },
          queryJson: true,
          cache: 60,
          requestClientCache: 1,
        }] : null;
        return cfg;
      }
    },
    reliabilityCreator: {
      $wait: ['project'],
      $callback: (data) => {
        const cfg = {};
        const id = get(data, 'project.data[0].reliability_data.developerId');

        cfg.creator = id ? [DataProvider.preload, {
          url: 'bildcontrol/clients-list',
          query: { id },
          queryJson: true,
          cache: 60,
          requestClientCache: 1,
        }] : null;
        return cfg;
      }
    },
    stocksLC: {
      $wait: ['project'],
      $callback: (data) => {
        const cfg = {};
        const geoJson = get(data, 'project.data[0].geo_centroid');
        const type = get(data, 'project.data[0].type');
        if (!geoJson) return {};
        geoJson.parameters = { distance: 10000 };
        cfg.stocksLC = [DataProvider.preload, {
          url: 'bild/newbuilds-list',
          query: {
            stocks: true,
            geoDWithin: geoJson,
            limit: 4,
            idNot: landing.params.complex.id,
            distanceColumn: geoJson,
            distanceOrder: 'asc',
            type,
            unsold: true
          },
          queryJson: true,
          cache: 60,
          requestClientCache: 1,
        }];
        return cfg;
      }
    },
    bildMainMenuBase: [DataProvider.preload, {
      url: 'core/menu',
      cache: 60 * 24,
      query: {
        project: 'bild'
      }
    }],
    makeOrderType: [Dict.preload, { url: 'reliability/make-order-type' }],
    orderStatus: [Dict.preload, { url: 'reliability/order-status' }],
    // ...blockPreloader({
    //   project: 'bild',
    //   entity: 'complexPage'
    // }, blocksConfig, ['project', 'landing']),
    // pdfPreviewImages: [Dict.preload, { url: 'reliability/pdf-preview-images' }] // pdf preview
  };

  if (content === 'project') {
    config = {
      ...config,
      ...simpleCheck(['project']),
      ...seoPreload({ entity: 'complexPage' }, ['project'])
    };
  }
  return config;
})
@seoDecorator({
  advancedVars: {
    plansHeader: 'Заголовок планировок',
    variantsHeader: 'Заголовок вариантов покупки',
    optsHeader: 'Заголовок характеристик',
    bottomText: 'Текст в самом низу'
  }
})
@mstatDecorator(marketStatEvents.historyChange, props => ({ entity: 'Страница ЖК/КГ', entityId: get(props, 'project.data[0].id') }))
@I18nHoc(translates())
export default class PageProject extends Component {
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
      ]),
      pageType: PropTypes.string,
      project: PropTypes.string,
      content: PropTypes.string
    }),
    project: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    seoData: PropTypes.shape({}),
    makeOrderType: PropTypes.shape({}),
    // pdfPreviewImages: PropTypes.shape({}),// pdf preview
    orderStatus: PropTypes.shape({}),
    stocksLC: PropTypes.shape({}),
    bildMainMenuBase: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({}))
    }),
  };

  renderToBack() {
    // const backUrl = getBackUrl();

    return (
      <div {...classesBemToBack()}>
        <Row {...classesBemToBack('row')}>
          <Col {...classesBemToBack('col')} allFlex allColumn allPr={0}>
            {/*backUrl &&
              <Link
                {...classesBemToBack('link', 'toBack')}
                {...backUrl}
              >
                <span {...classesBemToBack('linkContent')}>
                  <Icon {...classesBemToBack('icon')} type={iconTypes.arrowLeft} />
                  <span {...classesBemToBack('text')} children={this.i18n('linkToBackText')} />
                </span>
              </Link>
            */}
          </Col>
        </Row>
      </div>
    );
  }

  renderContent() {
    const {
      project, params = {}, seoData, makeOrderType, orderStatus,
      stocksLC, bildMainMenuBase
    } = this.props;
    const { content } = params;
    const creatorsData = get(this, 'props.creators.creatorList.data');
    const reliabilityCreator = get(this, 'props.reliabilityCreator.creator.data[0]');
    const orderId = get(this, 'props.location.query.order_id');
    const locationHash = get(this, 'props.location.hash');

    let promocode = null;
    if (locationHash) {
      promocode = locationHash.match(/promocode(.*)/);
      promocode = promocode ? promocode[1] : null;
    }

    // const cleanPdfPreview = JSON.parse(pdfPreviewImages.data['0'].value).images; // pdf preview
    // *** Project content renderer
    if (content === 'project') {
      return (
        <ContentProject
          project={project.data[0]}
          seoData={seoData}
          creators={creatorsData}
          reliabilityCreator={reliabilityCreator}
          makeOrderType={makeOrderType}
          // pdfPreviewImages={cleanPdfPreview}
          orderStatus={orderStatus}
          orderId={orderId}
          stocksLC={stocksLC}
          bildMainMenuBase={bildMainMenuBase}
          promocode={promocode}
        />
      );
    }
  }

  render() {
    const { project, seoData, params: { landing } } = this.props;
    const projectData = project.data[0];
    const { id } = projectData;
    const seoText = get(seoData, 'bottomText');

    return (
      <div>
        <Counter
          entity={{
            project_id: id
          }}
          mode="view"
          action="pageProjectView"
        />
        {this.renderToBack()}
        {this.renderContent()}
        <Container body>
          <Breadcrumbs
            data={landing.breadcrumbs}
            replace={{
              $newbuild: projectData.display_name,
            }}
          />
          <SeoText data={seoText} />
        </Container>
      </div>
    );
  }
}
